import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=c94fcd94&scoped=true&"
import script from "./ShareDialog.vue?vue&type=script&lang=js&"
export * from "./ShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&id=c94fcd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94fcd94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c94fcd94')) {
      api.createRecord('c94fcd94', component.options)
    } else {
      api.reload('c94fcd94', component.options)
    }
    module.hot.accept("./ShareDialog.vue?vue&type=template&id=c94fcd94&scoped=true&", function () {
      api.rerender('c94fcd94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/media/ShareDialog.vue"
export default component.exports